import axiosInstance from "./axiosInstance";
import useSWR from "swr";

const ensureUtcSuffix = (d) => {
  if (!d) return d;
  return /(?:Z|[+-]\d{2}:?\d{2})$/.test(d) ? d : `${d}Z`;
};

export async function cashflowGet(date, size, walletId, tagNames, startDate, finishDate, keyword) {
  size = size || 5;
  walletId = walletId === "0" ? undefined : walletId;
  let url = `/transaction?limit=${size}`;
  if (date) url += "&date=" + encodeURIComponent(ensureUtcSuffix(date));
  if (walletId) url += "&walletId=" + walletId;
  if (tagNames && tagNames.length > 0) url += "&tags=" + tagNames.join(",");
  if (startDate) url += "&startDate=" + encodeURIComponent(startDate);
  if (finishDate) url += "&finishDate=" + encodeURIComponent(finishDate);
  if (keyword && keyword.trim().length > 0) {
    url += "&keyword=" + encodeURIComponent(keyword.trim());
  }
  return await axiosInstance.get(url);
}

export async function cashflowPost(data) {
  return await axiosInstance.post("/transaction", data);
}

export async function cashflowUpdate(data) {
  return await axiosInstance.put("/transaction", data);
}

export async function cashflowDelete(id) {
  return await axiosInstance.delete("/transaction/" + id);
}

export const useCashflowTotal = () => {
  const { data } = useSWR("/transaction/total");
  return {
    totalCashflow: data ? data.sum || 0 : 0,
    loading: data === undefined,
  };
};
